/**
 * Prism OS — uz tarjima (default).
 *
 * Tuzilma: nuqta orqali nested. Masalan: `t("chatbot.dashboard.title")`.
 * Yo'qolgan key bo'lsa — key string'ning o'zi qaytadi.
 */

import type { Dictionary } from "../types";

export const uz: Dictionary = {
  common: {
    loading: "Yuklanmoqda...",
    error: "Xatolik yuz berdi",
    retry: "Qayta urinish",
    save: "Saqlash",
    cancel: "Bekor qilish",
    delete: "O'chirish",
    edit: "Tahrirlash",
    close: "Yopish",
    confirm: "Tasdiqlash",
    search: "Qidirish",
    filter: "Filtr",
    export: "CSV eksport",
    refresh: "Yangilash",
    back: "Orqaga",
    next: "Keyingi",
    previous: "Avvalgi",
    submit: "Yuborish",
    actions: "Amallar",
    yes: "Ha",
    no: "Yo'q",
    empty: "Ma'lumot yo'q",
    today: "Bugun",
    yesterday: "Kecha",
    last7: "So'nggi 7 kun",
    last30: "So'nggi 30 kun",
    last90: "So'nggi 90 kun",
    settings: "Sozlamalar",
    logout: "Chiqish",
    language: "Til",
    languageUz: "O'zbek",
    languageEn: "English",
  },
  nav: {
    home: "Bosh sahifa",
    sales: "Sotuv",
    marketing: "Marketing",
    chatbot: "Chatbot",
    coach: "Murabbiy",
    settings: "Sozlamalar",
  },
  chatbot: {
    nav: {
      dashboard: "Dashboard",
      inbox: "Inbox",
      analytics: "Analitika",
      leads: "Lidlar",
      knowledge: "Bilim bazasi",
      channels: "Kanallar",
      demo: "Demo rejim",
    },
    dashboard: {
      title: "Chatbot dashboard",
      subtitle: "Real-time chatbot ko'rsatkichlari va lead funnel",
      kpi: {
        activeConversations: "Aktiv suhbatlar",
        avgResponseTime: "O'rtacha javob vaqti",
        conversionRate: "Konversiya darajasi",
        totalLeads: "Jami lidlar",
      },
      sections: {
        funnel: "Reklama → Chat → Lead → Deal funnel",
        recentConversations: "So'nggi suhbatlar",
        aiAcceptRate: "AI takliflari qabul ko'rsatkichi",
        channelBreakdown: "Kanallar bo'yicha",
      },
      empty: "Hali suhbatlar yo'q",
    },
    analytics: {
      title: "Chatbot analitikasi",
      subtitle: "Chuqur tahlil va export",
      filters: {
        period: "Davr",
        channel: "Kanal",
        agent: "Operator",
      },
      charts: {
        dailyVolume: "Kunlik suhbat hajmi",
        responseTime: "Javob vaqti taqsimoti",
        intentBreakdown: "Intent taqsimoti",
        topFaq: "Eng ko'p FAQ savollar",
        aiHumanRatio: "AI vs operator nisbati",
        leadTimeline: "Lead konversiya dinamikasi",
      },
    },
    leads: {
      title: "Chatbot lidlari",
      subtitle: "Chatbot orqali yaratilgan barcha lidlar",
      columns: {
        contact: "Mijoz",
        intent: "Intent",
        channel: "Kanal",
        amoStatus: "AmoCRM",
        createdAt: "Yaratildi",
        source: "Manba",
      },
      amoStatus: {
        synced: "Sinxron",
        pending: "Kutilmoqda",
        failed: "Xato",
        notSynced: "Sinxron emas",
      },
    },
    funnel: {
      ad: "Reklama",
      chat: "Chat",
      lead: "Lead",
      deal: "Deal",
    },
    intent: {
      FAQ: "FAQ",
      BUYER_INTENT: "Sotib olish niyati",
      OBJECTION: "E'tiroz",
      COMPLAINT: "Shikoyat",
      SMALL_TALK: "Suhbat",
      OTHER: "Boshqa",
    },
    demo: {
      title: "Meta App Review demo",
      banner: "Meta Reviewer Demo Mode — English UI",
      steps: {
        connect: "Connect Instagram",
        selectAccount: "Select Business account",
        inbox: "View Inbox (live messages)",
        reply: "Accept AI suggestion + Reply",
        verify: "Verify on Instagram app",
        comments: "Comment management",
      },
      next: "Keyingi qadam",
      done: "Yakunlash",
    },
  },
  legal: {
    privacy: {
      title: "Maxfiylik siyosati",
      lastUpdated: "Yangilangan: 2026-05-07",
    },
    terms: {
      title: "Foydalanish shartlari",
      lastUpdated: "Yangilangan: 2026-05-07",
    },
    deletion: {
      title: "Ma'lumot o'chirish so'rovi",
      description:
        "Bu yerda Meta orqali yig'ilgan ma'lumotlaringizni o'chirish so'rovini yuborishingiz mumkin.",
      submit: "So'rov yuborish",
      success: "So'rov qabul qilindi",
    },
  },
  errors: {
    generic: "Kutilmagan xatolik",
    network: "Tarmoq xatosi. Qayta urinib ko'ring",
    forbidden: "Ruxsat yo'q",
    notFound: "Topilmadi",
    server: "Server xatosi",
  },
};
